import { downloadInvoicePdf } from '@/lib/file-actions';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

interface InvoicePdfButtonProps {
  invoiceId: string;
  invoiceNumber: string;
}

export function InvoicePdfButton({ invoiceId, invoiceNumber }: InvoicePdfButtonProps) {
  const handleDownload = () => {
    void downloadInvoicePdf(invoiceId, invoiceNumber);
  };

  return (
    <Button variant="outline" onClick={handleDownload}>
      <Download className="mr-2 h-4 w-4" />
      Download PDF
    </Button>
  );
}
